import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WaitlistModel } from 'src/app/core/models/waitlist-model';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { AppData } from 'src/app/app.data';
import { Patient } from 'src/app/core/interfaces/patient';
import { Settings } from 'src/app/app.settings.model';
import { WaitlistService } from '../waitlist.service';
import { ApiResponseCode } from 'src/app/core/enums';

@Component({
  selector: 'app-waitlist-item-menu',
  templateUrl: './waitlist-item-menu.component.html',
  styleUrls: ['./waitlist-item-menu.component.scss']
})
export class WaitlistItemMenuComponent implements OnInit {

  @Input() waitlistItem: WaitlistModel;
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() createAppt: EventEmitter<any> = new EventEmitter();

  settings: Settings;
  patient: Patient;
  canCreateAppointment: boolean;
  error: string;
  STATUS_VACANT: number;

  constructor(
    public translate: TranslateService,
    public authService: AuthenticateService,
    private router: Router,
    public appSettings: AppSettings,
    public waitlistService: WaitlistService,
    private appData: AppData) {

    this.STATUS_VACANT = 2;
    this.settings = appSettings.settings;
  }

  ngOnInit() {
    
    this.patient = { 
      ID: +this.waitlistItem.Customer.Identity, 
      Name: this.waitlistItem.Customer.Name,
      Email: this.waitlistItem.Customer.Email
    };
    this.canCreateAppointment = this.waitlistItem.Status === this.STATUS_VACANT;
  }

  onEdit() {
    this.appData.appointment = null;
    this.appData.waitlistItem = this.waitlistItem; // session stor item data
    this.router.navigate(['/standby', { waitlistItemID: this.waitlistItem.SchedulerWaitListID}]);
  }

  onCreateAppointment() {
    this.createAppt.emit(this.waitlistItem);
  }

  onDelete() {
    this.delete.emit(this.waitlistItem);
  }

}
